export interface MemeCategory {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  cover: string;
}

export interface MemeComment {
  user: string;
  text: string;
  likes: number;
}

export interface MemeItem {
  id: string;
  title: string;
  category: string;
  categoryName: string;
  cover: string;
  tags: string[];
  hot: number;
  downloads: number;
  date: string;
  author: string;
  summary: string;
  points: string[];
  comments: MemeComment[];
}

export const memeCategories: MemeCategory[] = [
  {
    slug: "gengtu",
    name: "梗图",
    desc: "把当时的情绪一口气说清楚的单张图，聊天里最常用的那批都在这儿。",
    icon: "ri-image-2-line",
    cover:
      "https://readdy.ai/api/search-image?query=a%20young%20office%20worker%20staring%20at%20a%20laptop%20screen%20with%20a%20dramatically%20shocked%20face%20surrounded%20by%20floating%20comic%20exclamation%20marks%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=800&height=600&seq=cat-gengtu-01&orientation=landscape",
  },
  {
    slug: "biaoqingbao",
    name: "表情包",
    desc: "成套的情绪包，从无语、震惊到阴阳怪气，斗图从不会缺弹药。",
    icon: "ri-emotion-happy-line",
    cover:
      "https://readdy.ai/api/search-image?query=a%20fluffy%20round%20cat%20face%20making%20a%20cheeky%20grin%20with%20sparkly%20eyes%20and%20a%20tiny%20raised%20paw%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=800&height=600&seq=cat-bqb-01&orientation=landscape",
  },
  {
    slug: "shenping",
    name: "神评论",
    desc: "评论区里一击命中的句子，配上图就是整条动态的灵魂。",
    icon: "ri-chat-quote-line",
    cover:
      "https://readdy.ai/api/search-image?query=a%20smartphone%20screen%20with%20a%20witty%20comment%20bubble%20and%20a%20laughing%20crowd%20of%20tiny%20emoji%20faces%20floating%20around%20it%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=800&height=600&seq=cat-shenping-01&orientation=landscape",
  },
  {
    slug: "erchuang",
    name: "网友二创",
    desc: "同一张图被玩出十几种版本，网友的脑洞永远比套路快一步。",
    icon: "ri-magic-line",
    cover:
      "https://readdy.ai/api/search-image?query=an%20artist%20character%20painting%20rainbow%20brush%20strokes%20over%20a%20funny%20picture%20with%20creative%20sparks%20flying%20everywhere%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=800&height=600&seq=cat-erchuang-01&orientation=landscape",
  },
  {
    slug: "gengji",
    name: "梗合集",
    desc: "按主题打包的成套素材，一次存够一整个星期的聊天弹药。",
    icon: "ri-stack-line",
    cover:
      "https://readdy.ai/api/search-image?query=a%20big%20stack%20of%20square%20picture%20cards%20fanned%20out%20like%20a%20deck%20with%20a%20spotlight%20on%20the%20top%20card%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=800&height=600&seq=cat-gengji-01&orientation=landscape",
  },
];

export const memeItems: MemeItem[] = [
  {
    id: "boss-overtime-speech",
    title: "领导说加班叫奋斗",
    category: "gengtu",
    categoryName: "梗图",
    cover:
      "https://readdy.ai/api/search-image?query=a%20cheerful%20cartoon%20boss%20pointing%20at%20a%20whiteboard%20with%20a%20clock%20showing%20late%20night%20while%20tiny%20workers%20hold%20picket%20signs%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=800&height=600&seq=meme-01-boss&orientation=landscape",
    tags: ["打工人", "职场", "加班", "无语"],
    hot: 9820,
    downloads: 3210,
    date: "2026-09-11",
    author: "瓜田编辑部",
    summary:
      "会议快结束时领导一句「年轻人要把加班当成奋斗」，配这张图基本不用再多解释。图里时钟指着深夜，白板上还写着明天的排期，情绪表达非常直接。",
    points: [
      "适合在群里回应临时加排期的通知，情绪浓但不带攻击性",
      "单张图信息密度高，不用配文字也能看懂",
      "常与「打工人」系列表情包搭配使用",
    ],
    comments: [
      { user: "栗子不加冰", text: "这图我存了三份，工作群专用。", likes: 412 },
      { user: "周五不加班", text: "白板上那句排期太真实，刺痛了。", likes: 287 },
      { user: "摸鱼中队长", text: "配字用「好的收到」，杀伤力翻倍。", likes: 233 },
    ],
  },
  {
    id: "monday-morning-me",
    title: "周一早上的我",
    category: "biaoqingbao",
    categoryName: "表情包",
    cover:
      "https://readdy.ai/api/search-image?query=a%20sleepy%20cartoon%20character%20with%20messy%20hair%20hiding%20under%20a%20blanket%20refusing%20to%20leave%20bed%20on%20a%20monday%20morning%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=800&height=600&seq=meme-02-monday&orientation=landscape",
    tags: ["早八", "起床", "情绪", "日常"],
    hot: 8760,
    downloads: 2890,
    date: "2026-09-10",
    author: "网友投稿",
    summary:
      "闹钟响了三遍、被子像有磁力，这张图把「再睡五分钟」的心情画得清清楚楚。整套一共四张，覆盖闹钟响、赖床、被迫起身和出门前手忙脚乱四个阶段。",
    points: [
      "四张连发可以当一条完整的起床小剧场",
      "线条简单，缩小到聊天表情尺寸依然清楚",
      "适合发给同样早起困难的室友和朋友",
    ],
    comments: [
      { user: "闹钟收藏家", text: "第三张就是我本人，谢谢。", likes: 356 },
      { user: "柠檬气泡", text: "存了发室友，他昨天还说我赖床。", likes: 194 },
      { user: "晨跑选手老吴", text: "我不需要这个（默默保存）。", likes: 158 },
    ],
  },
  {
    id: "netizen-sharp-tongue",
    title: "这届网友的嘴是真不留情",
    category: "shenping",
    categoryName: "神评论",
    cover:
      "https://readdy.ai/api/search-image?query=a%20witty%20cartoon%20comment%20bubble%20overflowing%20with%20tiny%20laughing%20emoji%20heads%20and%20one%20cheeky%20grinning%20face%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=800&height=600&seq=meme-03-comment&orientation=landscape",
    tags: ["评论区", "嘴替", "金句"],
    hot: 8210,
    downloads: 1760,
    date: "2026-09-09",
    author: "瓜田编辑部",
    summary:
      "把近期评论区里最能一句话收尾的发言集中整理成卡片。每张卡片保留原句的节奏感，只做标点整理，读起来依旧带劲。",
    points: [
      "每张卡片都是独立金句，适合单独转发",
      "按「吐槽」「安慰」「反杀」三种语气分类",
      "适合做图文帖的收尾配图",
    ],
    comments: [
      { user: "评论区常驻嘉宾", text: "「反杀」那一组建议单独出一份。", likes: 301 },
      { user: "夜航船", text: "整理得挺克制，原话的味道还在。", likes: 176 },
      { user: "不吃香菜", text: "看一遍笑一遍，嘴替在线。", likes: 143 },
    ],
  },
  {
    id: "milk-tea-keyboard",
    title: "当我把奶茶打翻在键盘上",
    category: "gengtu",
    categoryName: "梗图",
    cover:
      "https://readdy.ai/api/search-image?query=a%20panicked%20cartoon%20character%20spilling%20a%20milk%20tea%20cup%20onto%20a%20laptop%20keyboard%20with%20dramatic%20splash%20shapes%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=800&height=600&seq=meme-04-milktea&orientation=landscape",
    tags: ["翻车现场", "办公室", "惨"],
    hot: 7690,
    downloads: 2140,
    date: "2026-09-08",
    author: "网友投稿",
    summary:
      "一杯奶茶倒下只需要半秒，抢救键盘却要一整个下午。这张图的张力全在溅起的奶茶和主角的表情上，用来记录「今天有点水逆」刚刚好。",
    points: [
      "适合配一句「这是今天的第一个惊喜」使用",
      "画面留白多，方便自己加文字",
      "常被用在工位吐槽类动态里",
    ],
    comments: [
      { user: "键盘保护协会", text: "看到就手一抖，太有代入感了。", likes: 245 },
      { user: "少糖去冰", text: "建议旁边P一句「无糖也救不了」。", likes: 187 },
      { user: "阿凯", text: "上周刚经历，收藏了。", likes: 121 },
    ],
  },
  {
    id: "boss-big-pie",
    title: "老板画的饼有多大",
    category: "erchuang",
    categoryName: "网友二创",
    cover:
      "https://readdy.ai/api/search-image?query=a%20cartoon%20boss%20holding%20an%20enormous%20floating%20pie%20above%20a%20tiny%20hopeful%20employee%20with%20wide%20shining%20eyes%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=800&height=600&seq=meme-05-pie&orientation=landscape",
    tags: ["职场", "二创", "画饼", "反讽"],
    hot: 7340,
    downloads: 1980,
    date: "2026-09-07",
    author: "二创作者：小满不加班",
    summary:
      "原图只是一个夸张的饼，这位作者把「饼」按现实里的说法换了好几版：期权饼、升职饼、明年饼。同一个构图，越看越有层次。",
    points: [
      "同构图三版并列，可以拼成一张长图",
      "作者保留了原始线稿，方便二次修改",
      "适合做职场话题的配图",
    ],
    comments: [
      { user: "期权还没到账", text: "「明年饼」那一版建议裱起来。", likes: 268 },
      { user: "设计师小林", text: "线稿放出来太良心了，谢作者。", likes: 199 },
      { user: "早退冠军", text: "笑不出来，但确实好笑。", likes: 156 },
    ],
  },
  {
    id: "worker-coffee-pack",
    title: "打工人续命表情包合集",
    category: "gengji",
    categoryName: "梗合集",
    cover:
      "https://readdy.ai/api/search-image?query=a%20tired%20cartoon%20office%20worker%20drinking%20coffee%20with%20spiral%20eyes%20surrounded%20by%20floating%20coffee%20cups%20and%20tiny%20hearts%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=800&height=600&seq=meme-06-coffee&orientation=landscape",
    tags: ["合集", "打工人", "咖啡", "成套"],
    hot: 6980,
    downloads: 4120,
    date: "2026-09-06",
    author: "瓜田编辑部",
    summary:
      "一套十六张的成套素材，覆盖上午提神、午后续命、下班前放空三种状态。风格统一，尺寸一致，适合一次性存进聊天收藏夹。",
    points: [
      "16 张成套，画风与配色完全统一",
      "每张都留了文字位，可以自己加台词",
      "适合做个人收藏夹的固定素材库",
    ],
    comments: [
      { user: "三杯起步", text: "一套下完，这周斗图稳了。", likes: 322 },
      { user: "午后断电", text: "「下班前放空」那张过于真实。", likes: 211 },
      { user: "小周", text: "希望再出一套开会专用的。", likes: 168 },
    ],
  },
  {
    id: "client-one-punctuation",
    title: "甲方：就改一个标点",
    category: "erchuang",
    categoryName: "网友二创",
    cover:
      "https://readdy.ai/api/search-image?query=a%20cartoon%20client%20politely%20pointing%20at%20a%20giant%20document%20while%20the%20designer%20melts%20into%20a%20small%20puddle%20of%20despair%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=800&height=600&seq=meme-07-client&orientation=landscape",
    tags: ["设计", "二创", "甲方", "改稿"],
    hot: 6640,
    downloads: 1830,
    date: "2026-09-05",
    author: "二创作者：阿栗",
    summary:
      "「就改一个标点」之后通常还有十七个附件。作者用融化的小人表达设计师的心情，夸张但不失真实，是近期二创区转发量很高的一张。",
    points: [
      "融化效果做了逐帧拆解，可以当动图参考",
      "构图支持裁剪成头像尺寸",
      "适合搭配「收到，马上改」使用",
    ],
    comments: [
      { user: "改稿第一万次", text: "融化那段我能循环看一天。", likes: 276 },
      { user: "字体控", text: "细节做得挺讲究，文件都画出来了。", likes: 184 },
      { user: "夜班设计", text: "看完沉默，然后转发工作群。", likes: 152 },
    ],
  },
  {
    id: "early-eight-student",
    title: "早八人真实写照",
    category: "biaoqingbao",
    categoryName: "表情包",
    cover:
      "https://readdy.ai/api/search-image?query=a%20cartoon%20student%20rushing%20out%20the%20door%20half%20dressed%20holding%20toast%20with%20an%20alarm%20clock%20flying%20in%20the%20air%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=800&height=600&seq=meme-08-early&orientation=landscape",
    tags: ["学生党", "早八", "赶时间", "日常"],
    hot: 6120,
    downloads: 2240,
    date: "2026-09-04",
    author: "网友投稿",
    summary:
      "一只手抓着吐司、一只脚还没穿好鞋，闹钟在空中飞。这张图几乎是每个早八人的固定画面，群里发出来共鸣感特别强。",
    points: [
      "动作线明显，缩到小尺寸也看得懂",
      "适合和「周一早上的我」连发，效果加倍",
      "支持透明背景版本，方便贴到任何地方",
    ],
    comments: [
      { user: "卡着点进教室", text: "手里的吐司太写实了，我每天都这样。", likes: 233 },
      { user: "宿舍楼常客", text: "连发两张，整条动态就活了。", likes: 165 },
      { user: "小柯", text: "透明背景版是刚需，感谢。", likes: 129 },
    ],
  },
  {
    id: "cat-read-no-reply",
    title: "猫猫已读不回",
    category: "biaoqingbao",
    categoryName: "表情包",
    cover:
      "https://readdy.ai/api/search-image?query=a%20smug%20cartoon%20cat%20looking%20at%20a%20phone%20screen%20and%20deliberately%20ignoring%20a%20message%20with%20a%20tiny%20smirk%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=800&height=600&seq=meme-09-cat&orientation=landscape",
    tags: ["猫猫", "已读不回", "敷衍", "萌"],
    hot: 5840,
    downloads: 2560,
    date: "2026-09-03",
    author: "网友投稿",
    summary:
      "猫爪搭在手机上，眼睛却看向别处，标准的「看到了但不打算回」。这套一共六张，把敷衍、走神、装忙三种状态都画了出来。",
    points: [
      "六张成套，覆盖不同程度的不想回复",
      "猫的表情层次细腻，适合截图当头像",
      "适合用在不想接话又不想冷场的场合",
    ],
    comments: [
      { user: "铲屎官小戴", text: "我家猫真的有这个表情，一模一样。", likes: 248 },
      { user: "消息免打扰", text: "敷衍那张已经设成常用表情了。", likes: 176 },
      { user: "阿禾", text: "不冒犯但意思很到位，好评。", likes: 138 },
    ],
  },
  {
    id: "keyboard-hero-comment",
    title: "评论区的嘴替上线了",
    category: "shenping",
    categoryName: "神评论",
    cover:
      "https://readdy.ai/api/search-image?query=a%20heroic%20cartoon%20character%20in%20a%20small%20cape%20typing%20boldly%20on%20a%20keyboard%20next%20to%20a%20speech%20bubble%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=800&height=600&seq=meme-10-hero&orientation=landscape",
    tags: ["嘴替", "评论区", "金句", "盖楼"],
    hot: 5560,
    downloads: 1420,
    date: "2026-09-02",
    author: "瓜田编辑部",
    summary:
      "当一条评论说出了所有人想说却没说出口的话，大家就会喊一句「嘴替」。这一组把网友整理的高赞发言做成卡片，配上披风小人的形象，读起来很有画面感。",
    points: [
      "每张卡片都是完整的一句话，适合直接转发",
      "配有语气标签，方便按场景挑图",
      "适合做话题贴的置顶配图",
    ],
    comments: [
      { user: "盖楼第一人", text: "披风小人有点可爱，希望能出周边。", likes: 201 },
      { user: "深夜刷帖", text: "「语气标签」这个设计很贴心。", likes: 158 },
      { user: "路过群众", text: "存了几张，下次吵架用。", likes: 132 },
    ],
  },
];

export const heroShowcase = [
  {
    src: "https://readdy.ai/api/search-image?query=a%20lively%20group%20of%20cartoon%20characters%20laughing%20together%20while%20looking%20at%20phone%20screens%20and%20holding%20funny%20picture%20cards%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=600&height=800&seq=hero-card-01&orientation=portrait",
    alt: "网友围在一起看梗图并大笑的卡通插画",
    label: "今日最热",
  },
  {
    src: "https://readdy.ai/api/search-image?query=a%20cheerful%20cartoon%20melon%20character%20with%20a%20big%20smile%20wearing%20sunglasses%20and%20holding%20a%20laughing%20emoji%20sign%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=600&height=800&seq=hero-card-02&orientation=portrait",
    alt: "举着笑脸牌子吃瓜的卡通西瓜形象",
    label: "吃瓜现场",
  },
  {
    src: "https://readdy.ai/api/search-image?query=a%20cartoon%20character%20scrolling%20through%20a%20phone%20gallery%20of%20funny%20reaction%20images%20with%20stars%20and%20sparkles%20around%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=600&height=800&seq=hero-card-03&orientation=portrait",
    alt: "在手机上翻看表情包素材的卡通人物",
    label: "表情包库",
  },
];

export const erchuangFeature = {
  src: "https://readdy.ai/api/search-image?query=a%20creative%20cartoon%20artist%20at%20a%20desk%20surrounded%20by%20colorful%20sketches%20and%20funny%20facial%20expression%20studies%2C%20flat%20vector%20cartoon%20illustration%2C%20cute%20expressive%20character%20with%20comedic%20reaction%2C%20warm%20coral%20red%20cream%20and%20olive%20green%20palette%2C%20playful%20internet%20meme%20aesthetic%2C%20simple%20solid%20cream%20background%2C%20soft%20rounded%20shapes&width=1200&height=800&seq=erchuang-feature-01&orientation=landscape",
  alt: "二创作者在堆满草图的工作台前创作的插画",
};